import { useUserStore } from "@/store/userStore";

export function userCan(permission) {
  if (userHasRole("admin")) return true;
  const userStore = useUserStore();
  const user = userStore.user;

  if (!user.id || !Array.isArray(user.permissionsList)) return false;

  return user.permissionsList.includes(permission);
}

export function userHasRole(role) {

  const userStore = useUserStore();
  const user = userStore.user;

  if (!user.id || !user.roleInfo) return false;

  if (user.roleInfo.name == 'admin') return true;

  return user.roleInfo.name == role;
}

export function isUserLoggedIn() {
  const userStr = localStorage.getItem("user_data");
  return !!userStr;
}


export default {
  userCan,
  userHasRole,
  isUserLoggedIn,
};
